/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import { literal } from '../util.type';

/**
 * Číselník všech podporovaných update platforem, který je podmnožinou
 * číselníku `RuntimePlatform`.
 *
 * Hodnoty záměrně 1:1 odpovídají stringům v update JSON manifestu
 * (`CommunicatorManifest`), v `SentryLogger` položce `updatePlatform`
 * a v `CommunicatorReport` klíči `app.update.type.light.updatePlatform`.
 * @enum {'kiwi-lighter-1' | 'tizen-sssp-4' | 'web' | 'webos-signage-3.0'}
 * @readonly
 */
const UpdatePlatform = {
  /** Update platforma pro Ki-Wi Lighter API ve verzi 1. */
  KiwiLighter1: literal('kiwi-lighter-1'),
  /** Update platforma pro Samsung Smart Signage Platform verze 4. */
  TizenSssp4: literal('tizen-sssp-4'),
  /** Update platforma pro standardní webové technologie. */
  Web: literal('web'),
  /** Update platforma pro LG webOS Smart Signage Platform ve verzi 3.0. */
  WebosSignage3_0: literal('webos-signage-3.0')
};

export default UpdatePlatform;
